import { render } from "./renamegroup.vue?vue&type=template&id=62c1fa5d"
import script from "./renamegroup.vue?vue&type=script&lang=js"
export * from "./renamegroup.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__